module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectel":"Selectel Ltd.","lecense":"Telematic service license","and":"and"},"ru":{"selectel":"ООО «Селектел»","lecense":"Лицензия на телематические услуги","and":"и"}}')
  delete Component.options._Ctor
}
